import React, { FC } from 'react'
import AppBar from '@components/AppBar'
import { IProps } from './interface'

const AppBarContainer: FC<IProps> = () => (
  <div style={{paddingTop: 64}}>
    <AppBar/>
  </div>
)

export default AppBarContainer
